export default __webpack_public_path__ + "static/media/logoMb.70d0b73e.svg";